import { render, staticRenderFns } from "./iosyinsi.vue?vue&type=template&id=c93525be&scoped=true"
import script from "./iosyinsi.vue?vue&type=script&lang=js"
export * from "./iosyinsi.vue?vue&type=script&lang=js"
import style0 from "./iosyinsi.vue?vue&type=style&index=0&id=c93525be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93525be",
  null
  
)

export default component.exports